import { Quotation } from 'data-layer-cr/dist/models';
import {
  defaultUnitDriver,
  validLegalEntity,
} from 'data-layer-cr/dist/functions/quotations';
import { dateFormat } from 'design-system';
import CustomerItem, {
  makeEmptyCustomerItem,
} from '../models/helperTypes/CustomerItem';

import driverAndCustomerAreDifferent from './driverAndCustomerAreDifferent';

const { dateFromServerString } = dateFormat;

/**
 * Creates a DriverItem instance using the values provided by the quotation
 *
 * @param quotation - The quotation to use as the source
 */
export default function customerItemFromQuotation(
  quotation: Quotation,
): CustomerItem {
  const { customer } = quotation;
  const quotationDriver = defaultUnitDriver(quotation);
  const legalEntity = validLegalEntity(quotation);
  return {
    ...makeEmptyCustomerItem(),

    // Values related to legal entity
    type: quotation.customerType,
    entityName: legalEntity.name,

    // Values shared between customer and legal entity
    email: customer.email || legalEntity.email,
    phoneNumber: customer.phone || legalEntity.phone,
    sendEmailCreatorUser: quotation.sendEmailCreatorUser,

    // Customer information
    birthday: dateFromServerString(customer.birthday),
    firstName: customer.firstName,
    lastName: customer.lastName,
    gender: customer.gender,

    // This will check if the driver and the customer are different
    driverAndCustomerAreDifferent: driverAndCustomerAreDifferent(
      quotationDriver,
      customer,
    ),

    // Driver information
    driverFirstName: quotationDriver.firstName,
    driverLastName: quotationDriver.lastName,
    driverBirthday: dateFromServerString(quotationDriver.birthday),
    driverGender: quotationDriver.gender,

    transitZone: quotationDriver.transitZone,
    transitTime: quotationDriver.transitTime,

    /**
     * The quotation only saves the result obtained by offenses, collisions and
     * exonerations. Since we have currently no way of knowing which values were
     * the originals, we apply that result to offensesQty and set everything else
     * to 0. This should generate the same result.
     */
    offensesQty: parseInt(quotationDriver.foulsQty, 10),
    collisionsQty: 0,
    exonerationQty: 0,
    alcoholBreath: 0,
  };
}
